import { App } from 'antd';
import { useEffect } from 'react';

import { LiveRegion } from '@/a11y/liveRegion';
import { setMessageInstance } from '@/lib/message';

/**
 * Captures the context-aware message instance from AntD's <App> and hands it to
 * the message singleton in lib/message. Render once inside <App>.
 *
 * Also hosts the app's live regions. They live here because this component is
 * already the single always-mounted sibling of the toast system, and a live
 * region must be present in the DOM BEFORE its content changes for the change
 * to be announced at all.
 */
export function MessageBridge() {
  const { message } = App.useApp();
  useEffect(() => {
    setMessageInstance(message);
  }, [message]);
  return <LiveRegion />;
}
